import './_footer-links.scss';

export default () => {};
